import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectLogs, selectSelectedLogs, selectNumLogs, selectSearchQuery } from '../../../../../redux/admin/admin-selector';
import { setSelectedLogs } from '../../../../../redux/admin/admin-actions';
import './logs-table-header.stlyes.scss';

const LogsTableHeader = () => {
    const tableHeaderInfo = [
        {name: 'EVENT ID',
         containerClassName: 'th-event-id-col',
         sortBy: 'Module'
        },
        {name: 'EVENT TYPE',
         containerClassName: 'th-event-type-col',
         sortBy: 'Action'
        },
        {name: 'EVENT DETAIL',
         containerClassName: 'th-event-detail-col',
         sortBy: 'Note'
        },
        {name: 'IP ADDRESS',
         containerClassName: 'th-ip-address-col',
         sortBy: 'Ip'
        },
        {name: 'USER ID',
         containerClassName: 'th-createdBy-col',
         sortBy: 'UserId'
        },
        {name: 'CREATED DATE',
         containerClassName: 'th-created-date-col',
         sortBy: 'Created'
        }];
   
    return (
        <thead className="logs-table-header">
            <tr>
            {
                tableHeaderInfo.map((labelInfo, index) => {
                    return(
                        <th className= {labelInfo.containerClassName} key = {index}>
                            <div className="th-container">
                                <div className="th-name">{labelInfo.name}</div>
                            </div>
                        </th>
                    );
                })
            }
            </tr>
        </thead>
    )
}

const mapState = createStructuredSelector({
    data: selectLogs,
    selectedRows: selectSelectedLogs,
    numEntries: selectNumLogs,
    searchQueryRedux: selectSearchQuery
  });
  
  const mapDispatch = (dispatch) => ({
    setSelectedRows: idList => dispatch(setSelectedLogs(idList))
  });

export default connect(mapState, mapDispatch)(LogsTableHeader);
